import axios from "axios";

const rawAuthBase =
  process.env.REACT_APP_AUTH_BASE_URL ?? "";

const authBase = rawAuthBase.replace(/\/+$/, "");

const authClient = axios.create({
  baseURL: authBase,
});

const safeStorage = (name) => {
  try {
    return typeof window !== "undefined" ? window[name] : undefined;
  } catch {
    return undefined;
  }
};

const getAccessToken = () => {
  const ls = safeStorage("localStorage");
  const ss = safeStorage("sessionStorage");
  return ls?.getItem("accessToken") || ss?.getItem("accessToken");
};

authClient.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const authApi = {
  login: (payload) => authClient.post("/Auth/login", payload),
  me: () => authClient.get("/Auth/me"),
  createAdmin: (payload) => authClient.post("/Auth/create-admin", payload),
  logout: (payload) => authClient.post("/Auth/logout", payload),
  refresh: (payload) => authClient.post("/Auth/refresh", payload),
};

export default authApi;